var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContract(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1862_15782",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 200,
    height: 200
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1862_15782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 175C45.2991 175 41.3462 173.397 38.141 170.192C34.9359 166.987 33.3333 163.034 33.3333 158.333V135.256H58.3333V25H166.667V158.333C166.667 163.034 165.064 166.987 161.859 170.192C158.654 173.397 154.701 175 150 175H50ZM150 166.667C152.361 166.667 154.34 165.868 155.937 164.271C157.535 162.674 158.333 160.694 158.333 158.333V33.3333H66.6666V135.256H141.667V158.333C141.667 160.694 142.465 162.674 144.062 164.271C145.66 165.868 147.639 166.667 150 166.667ZM78.2052 69.8719V61.5385H146.795V69.8719H78.2052ZM78.2052 92.9487V84.6154H146.795V92.9487H78.2052ZM50 166.667H133.333V143.59H41.6666V158.333C41.6666 160.694 42.4653 162.674 44.0625 164.271C45.6597 165.868 47.6389 166.667 50 166.667ZM50 166.667H41.6666H133.333H50Z",
    fill: "#046AD0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.4c15229dd7edb27ed682fe03908b9a3b.svg";
export { ForwardRef as ReactComponent };